export class Authenticator {
    constructor(parser, validator) {
        this.parser = parser;
        this.validator = validator;
    }
    authenticate(token) {
        const header = this.parser.parseHeader(token);
        if (!this.validator.canValidate(header)) {
            return null;
        }
        const parsedToken = this.parser.parse(token);
        const isValid = this.validator.isValid(parsedToken);
        if (!isValid) {
            return null;
        }
        return parsedToken;
    }
}
export class AuthenticationFacadeFactory {
}
export class AuthenticationFacade {
    constructor(tokenSigner, tokenGenerator, authenticator) {
        this.tokenSigner = tokenSigner;
        this.tokenGenerator = tokenGenerator;
        this.authenticator = authenticator;
    }
    type() {
        return this.tokenSigner.alg;
    }
    subject() {
        return this.tokenSigner.subject;
    }
    generateToken(ttl) {
        return this.tokenGenerator.generate(ttl);
    }
    parseToken(token) {
        return this.authenticator.parser.parse(token);
    }
    canValidate(tokenHeader) {
        return this.authenticator.validator.canValidate(tokenHeader);
    }
    isValid(token) {
        return this.authenticator.validator.isValid(token);
    }
}
//# sourceMappingURL=authentication-facade.js.map